import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOmeMeetEntryInfoByOmeMeetIdData from './GetOmeMeetEntryInfoByOmeMeetIdData';

import Constants from '@usas/ui-web/utils/Constants';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE,
  omeMeetId: Constants.DEFAULT_ID,
  isCurrent: '',
  options: []
};

const OmeMeetEntryInfoData = {
  INITIAL_STATE, getOmeMeetEntryInfoByOmeMeetIdData
};

export default OmeMeetEntryInfoData;